import { ErrorNotificationStore } from "@/stores/error-store";

export const RECOVERABLE_FEED_HEADERS = {
  "x-skip-error-notification": "true"
} as const;

export function notifyRecoverableFeedError(error: {
  status?: number;
  message?: string;
}): void {
  if (error.status === 404) return;

  // AppHome reserves codes above 500 for a page-level error. A catalogue feed
  // is recoverable, so keep the existing visible server warning without
  // replacing its otherwise valid parent screen.
  const notificationStatus =
    error.status !== undefined && error.status >= 500 ? 500 : error.status;
  if (notificationStatus === undefined) return;
  ErrorNotificationStore.getInstance().notifyByStatus(
    notificationStatus,
    error.message
  );
}
